import { render, staticRenderFns } from "./ColorDelete.vue?vue&type=template&id=8fa66bc4&"
import script from "./ColorDelete.vue?vue&type=script&lang=js&"
export * from "./ColorDelete.vue?vue&type=script&lang=js&"
import style0 from "./ColorDelete.vue?vue&type=style&index=0&id=8fa66bc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports